export default __webpack_public_path__ + "static/media/work-2right-3.22369ba7.png";